import { Deserializable } from '../protocols/deserializable';
import { VariableBenefitPaymentAccountEstimate } from './variable-benefit-payment-account-estimate';

export class VariableBenefitPaymentEstimate implements Deserializable {
  public accounts: VariableBenefitPaymentAccountEstimate[] = [];
  public combinedRecurringAnnualTotal!: number;
  public combinedLumpSumTotal!: number;
  public combinedEstimatedAnnualTotal!: number;

  public onDeserialize(): void {
    this.accounts = window.injector.Deserialize.arrayOf(VariableBenefitPaymentAccountEstimate, this.accounts ?? []);
  }
}
